module.exports = __webpack_public_path__ + "img/pic5.42394a31.png";